import { RowCrudStatus } from "../../common/types";
import {
  ReportType,
  ReportTypeCreateMutationVariables,
  ReportTypeUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { blankToNull } from "../../../common/blankToNull";

export type ReportTypeValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  description: string;
};

export type ReportTypeErrorsType = {
  name?: { message: string; fieldLabel: string };
  description?: { message: string; fieldLabel: string };
};

export function ReportTypeValuesInit(): ReportTypeValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    description: "",
  };
}

export type ReportTypeType = ReportType | ReportTypeValuesType;

export function reportTypeDisplayId(
  source: Partial<ReportType>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getReportTypeValues(
  source: ReportTypeType,
  _langStore: LangStore,
  _duplicated: boolean = false
): ReportTypeValuesType {
  const entityValues = ReportTypeValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : reportTypeDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.description = source.description || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getReportTypeUpdateVariables(
  values: ReportTypeValuesType
): ReportTypeUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
    description: blankToNull(values.description),
  };
}

export function getReportTypeCreateVariables(
  values: ReportTypeValuesType
): ReportTypeCreateMutationVariables {
  return {
    name: values.name,
    description: blankToNull(values.description),
  };
}
